export default function AttachStatementDocumentDirective() {
  return {
    template: require('./attach-statement-document.html'),
    scope: {
      customerId: '=',
      criStatementId: '=',
      assessmentId: '=',
      serviceId: '=',
      parentDocumentId: '=',     
      documentId: '=',
      document: '=',
    },
    controller: 'AttachStatementDocumentController',
    controllerAs: 'attachStatementDocumentVM',
    bindToController: true,
    replace: true
  };
}
